const form = {
  formId: "form-inscricoes",
  formField: {
    observacao: {
      name: "observacao",
      label: "Justifique o motivo da baixa",
      type: "text",
      errorMsg: "Justificativa é obrigatório",
      invalidMsg: "A justificativa deve ter pelo menos 20 caracteres",
    },
  },
};

export default form;
